import useStarterPrompts from './useStarterPrompts';

// Chat uses account memory, independent of Work's selected folder and memory toggle.
export default function useChatStarterPrompts({ enabled = true, refreshKey = 0 } = {}) {
  return useStarterPrompts({ mode: 'chat', project: null, enabled, refreshKey });
}
